import EngineModule from '../../../EngineModule';
import {
	NS as StandingCarpetEditorNS
}                   from '../../../components/customers/standing/StandingCarpetImprintEditor/StandingCarpetImprintEditor';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'standing-carpetImprintEditor',
	dependencies :     [
		'oms-basket',
		'viewer-planner'
	],
	modulesBefore :    [
		'product-editor',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor',
		'viewer-planner-floor-editor'
	],
	modulesAfter :     [ 'viewer-planner-walls-editor' ],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	usableCondition :  {
		type : 'and',
		LHS :  {
			type :      'notequal',
			component : 'K',
			property :  'TARGET.currentProduct',
			value :     null
		},
		RHS :  {
			type :      'notequal',
			component : 'K',
			property :  '[*]TARGET.currentProduct.getPart(["layout"]).currentOption',
			value :     null
		},
	},
	displayCondition : {
		type :      'equal',
		component : 'K',
		property :  'TARGET.currentProduct.reference.value',
		value :     'business'
	},
	generateComponentConfiguration() : StandingCarpetEditorNS.Configuration {
		return {};
	},
	async initialize() {
	}
});
